export const deviceType = {
  ios: 'ios',
  amazonFire: 'amazon_fire',
  android: 'android',
  windowsPhone: 'windows_phone',
  otherMobile: 'other_mobile',
  mac: 'mac',
  linux: 'linux',
  windows: 'windows',
  otherDesktop: 'other_desktop',
  bot: 'bot'
};

export const appStoreType = {
  appleStore: 'apple_store',
  amazon: 'amazon',
  googlePlay: 'google_play',
  windows: 'windows'
};